<template>
  <div :class="[{ 'nav-open': $sidebar.showSidebar }]" class="wrapper">
    <notifications />

    <side-bar :active-color="sidebarBackground" :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor">
      <!-- <user-menu /> -->
      <!-- <mobile-menu /> -->

      <template slot="links">
        <sidebar-item class="user-profile-item" style="padding-bottom: 1rem;"
          :link="{ name: title, icon: 'person_outline', path: '/portal/admin' }">
          <sidebar-item :link="{ name: 'My Settings', icon: 'settings', path: '/portal/admin/my-settings' }" />
        </sidebar-item>
        <span class="user-role">Admin</span>
        <div style="border-bottom: solid 1px rgba(180, 180, 180, .3);margin-left: 1rem;margin-right: 1rem;"></div>
        <sidebar-item :link="{ name: 'Dashboard', icon: 'home', path: '/portal/admin/dashboard' }" />

        <!--       <sidebar-item :link="{ name: 'Messages', icon: 'mail_outline', path: '/portal/admin/messages' }" /> -->

        <p align="Left" class="menu-item-title">
          READING CENTER
        </p>

        <!--PACKAGES-->
        <sidebar-item :link="{ name: 'Packages', icon: 'cloud_upload', path: '/portal/admin/packages' }">
          <!-- <sidebar-item :link="{ name: 'Upload Tracking', icon: 'visibility', path: '/portal/admin/upload' }" />       -->
          <!-- <sidebar-item :link="{ name: 'Package Adjustments', icon: 'visibility', path: '/portal/admin/adjust' }" />   -->
        </sidebar-item>

        <!--SiView-->
        <sidebar-item :link="{ name: 'SiVIEW', icon: 'history', path: '/portal/admin/siview' }" />

        <!--DxCards-->
        <sidebar-item :link="{ name: 'DxCards', icon: 'style', path: '/portal/admin/dxcards' }" />

        <!--PATIENTS-->
        <sidebar-item :link="{ name: 'Patients', icon: 'person', path: '/portal/admin/patients-list' }" />

        <!--SCREENINGS-->
        <sidebar-item :link="{ name: 'Screenings', icon: 'visibility', path: '/portal/admin' }">
          <sidebar-item :link="{ name: 'Available', icon: 'visibility', path: '/portal/admin/screenings' }" />
          <sidebar-item :link="{ name: 'On-Hold', icon: 'visibility', path: '/portal/admin/Onhold' }" />
        </sidebar-item>

        <!-- BILLING -->
        <sidebar-item :link="{
          name: 'Billing',
          icon: 'attach_money',
          path: '/portal/admin/billing'
        }" />

        <!--REPORTS-->
        <sidebar-item :link="{ name: 'Reports', icon: 'assignment_ind', path: '/portal/admin/reports' }">
          <!-- <sidebar-item :link="{ name: 'Reports Generated', icon: 'assignment_ind', path: '/portal/admin/reports' }" /> -->
          <!-- <sidebar-item :link="{ name: 'Reports Aging', icon: 'assignment_ind', path: '/portal/admin/reports-aging' }" /> -->
        </sidebar-item>

        <!--DOCTORS #3c4858 - #404040 -->
        <sidebar-item :link="{ name: 'Doctors', icon: 'local_hospital', path: '/portal/admin/doctors-list' }">
          <!-- <sidebar-item :link="{ name: 'Pending Registrations', icon: 'local_hospital', path: '/portal/admin/doctors-pending' }"/> -->
          <!-- <sidebar-item :link="{ name: 'Search Doctors', icon: 'local_hospital', path: '/portal/admin/doctor-search' }" /> -->
          <!-- <sidebar-item :link="{ name: 'List Doctors', icon: 'local_hospital', path: '/portal/admin/doctors-list' }" /> -->
          <!-- <sidebar-item :link="{ name: 'List Practices', icon: 'local_hospital', path: '/portal/admin/practices-list' }" /> -->
        </sidebar-item>

        <sidebar-item :link="{ name: 'CPT', icon: 'list_alt', path: '/portal/admin/cpts' }" />

        <!--<p align="Left" style="font-size: .7rem; color: #ed7632; font-weight: 400; margin-left:10px;">PACKAGE MANAGEMENT</p>-->

        <p align="Left" class="menu-item-title">
          ADMINISTRATIVE
        </p>

        <!--USER MAINT -->
        <sidebar-item :link="{ name: 'Management', icon: 'stars', path: '/portal/admin' }">
          <sidebar-item :link="{ name: 'Users', icon: 'local_hospital', path: '/portal/admin/users' }" />
          <!-- <sidebar-item :link="{ name: 'Members', icon: 'local_hospital', path: '/portal/admin/members' }"/> -->
          <!-- <sidebar-item :link="{ name: 'Globes', icon: 'local_hospital', path: '/portal/admin/globes' }" /> -->

          <!-- <sidebar-item :link="{ name: 'Lists', icon: 'local_hospital', path: '/portal/admin/lists' }" /> -->
          <!-- <sidebar-item :link="{ name: 'Content', icon: 'local_hospital', path: '/portal/admin/content' }" /> -->
        </sidebar-item>
        <!-- <sidebar-item :link="{ name: 'Reporting', icon: 'reorder', path: '' }" /> -->

        <!-- <sidebar-item :link="{ name: 'Settings', icon: 'settings', path: '/portal/admin/settings' }" /> -->
        <div style="margin-top: 4rem;"></div>
      </template>
    </side-bar>

    <div class="main-panel">
      <top-navbar class="top-navbar" />

      <!--
      <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>
      -->

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view style="margin-top: 50px" align="Center" />
        </zoom-center-transition>
      </div>

      <content-footer v-if="!$route.meta.hideFooter" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar"
import "perfect-scrollbar/css/perfect-scrollbar.css"

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

import TopNavbar from "./TopNavbar.vue"
import ContentFooter from "./ContentFooter.vue"
import MobileMenu from "./Extra/MobileMenu.vue"
//import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue"
import { ZoomCenterTransition } from "vue2-transitions"

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    //FixedPlugin,
    UserMenu,
    ZoomCenterTransition
  },
  props: {
    title: {
      type: String,
      default: sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
    }
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "", //"./img/sidebar-0.jpg"
      sidebarMini: true,
      sidebarImg: true
    }
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar()
    }
  },
  mounted() {
    let docClasses = document.body.classList
    let isWindows = navigator.platform.startsWith("Win")
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar")
      initScrollbar("sidebar-wrapper")
      initScrollbar("main-panel")

      docClasses.add("perfect-scrollbar-on")
    } else {
      docClasses.add("perfect-scrollbar-off")
    }
    this.maximixeSidebar()
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    maximixeSidebar() {
      this.$sidebar.toggleMinimize()
    }
  }
}
</script>

<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
